export default "__VITE_ASSET__BHRpItUu__"